import Button from '@atlaskit/button/new';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import { Stack } from '@atlaskit/primitives/compiled';
import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';
import { Heading, Text } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import { useLoaderData, useNavigate } from 'react-router-dom';

import { useScreenEvent } from 'src/hooks/useScreenEvent';

import { PartnerCard } from './PartnerCard';
import { ClassPageLoaderProps } from '../../classPageLoader';

export const PartnersPage = () => {
  const navigate = useNavigate();
  const { contentfulILTData } = useLoaderData() as ClassPageLoaderProps;

  useScreenEvent({ eventName: 'privateClassScheduleScreen' });

  const onBackClick = () => navigate(-1);

  return (
    <Stack space="space.400">
      <div>
        <Button
          iconBefore={(iconProps) => <ArrowLeftIcon {...iconProps} color={token('color.text.brand')} />}
          appearance="subtle"
          onClick={onBackClick}
        >
          <span css={buttonTextStyles}>Back to class description</span>
        </Button>
      </div>
      <Heading level={0}>Schedule private class</Heading>
      <Text size="large">
        Connect with an Atlassian-authorized Training Partner for tailored solutions and proven results.
      </Text>
      <Text size="large">
        To get started, choose a Training Partner from the list below. Then either visit their website for more details
        and to set up your session, or contact them directly via email.
      </Text>

      <div css={gridContainerStyles} data-testid="training-partners-grid">
        {contentfulILTData.partnersCollection.items.map((partner) => (
          <PartnerCard key={partner.sys.id} partner={partner} />
        ))}
      </div>
    </Stack>
  );
};

const gridContainerStyles = css({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: token('space.300'),
  width: '100%',
  marginTop: token('space.200'),
  gridAutoRows: '1fr',

  // Tablet: 2 columns
  [media.above.sm]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },

  // Desktop: 3 columns with flexible sizing
  [media.above.md]: {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  },
});

const buttonTextStyles = css({
  color: token('color.text.brand'),
  textAlign: 'center',
  fontFamily: 'Charlie Text',
  fontSize: '1rem',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '1.25rem',
});
